import React from 'react'
import { StyledFooter } from './styled'

const Footer = props => (
  <StyledFooter>
    <small>v{process.env.REACT_APP_VERSION}</small>
    <small>{process.env.REACT_APP_ENV}</small>
  </StyledFooter>
)
export default Footer
